export default "__VITE_ASSET__Dr5R__cv__";